import { render } from "./Chip.vue?vue&type=template&id=18280d9a&ts=true"
import script from "./Chip.vue?vue&type=script&lang=ts"
export * from "./Chip.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/rewards/runners/app/root/reward-app/reward-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__